<template>
    <component :is="component" v-if="component" :historyData="historyData" :paginationData="paginationData"/>
</template>

<script>
export default {
    name: "HistoryDetailLink",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        detailLayout: '',
        historyData: {},
        paginationData: {default: {page: 1, current_page: 1, last_page: 2, per_page: 10}}
    },
    data() {
        return {
            component: null,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
        this.loader()
                .then(() => {
                    this.component = () => this.loader()
                })
                .catch(() => {
                    this.component = () => import('@/template/history/detail/HistoryDetailDefaultLayout')
                })
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        loader() {
            if (!this.detailLayout) {
                return null
            }
            return () => import(`@/template/history/detail/${this.detailLayout}`)
        },
    },
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
